const DeleteCustomerLog = {
  path: "",
  name: "",
  redirect: "/delete-customer",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/delete-customer",
      redirect: "/delete-customer",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Activity Log",
      meta: {
        requiresAuth: true,
        activeUrl: "/delete-customer",
        parent: "/delete-customer",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/deleteCustomerLog"),
          meta: {
            requiresAuth: true,
            activeUrl: "/delete-customer",
            parent: "/delete-customer",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Activity Log Detail",
          component: () => import("@/views/pages/deleteCustomerLog/Detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/delete-customer",
            parent: "/delete-customer",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default DeleteCustomerLog;
